import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TGAVarietiesState } from './tga-varieties.feature';
import { CropVariety } from '../models/tga-varieties.model';

export const selectTGAVarietiesState = createFeatureSelector<TGAVarietiesState>('tgaVarieties');

export const selectTGAVarietyProperties = createSelector(selectTGAVarietiesState, (state) => state.varietyProperties);

export const selectTGAVarietiesLoading = createSelector(selectTGAVarietiesState, (state) => state.loading);

export const selectTGAVarietiesError = createSelector(selectTGAVarietiesState, (state) => state.error);

// Derived selectors that extract unique lookup data from variety properties
export const selectDerivedCropVarieties = createSelector(selectTGAVarietyProperties, (varietyProperties): CropVariety[] => {
  const uniqueCropVarieties = new Map<number, CropVariety>();

  for (const vp of varietyProperties) {
    if (vp.ediCode && vp.cropVarietyName && !uniqueCropVarieties.has(vp.ediCode)) {
      uniqueCropVarieties.set(vp.ediCode, {
        ediCode: vp.ediCode,
        name: vp.cropVarietyName,
      });
    }
  }

  const derivedVarieties = Array.from(uniqueCropVarieties.values()).sort((a, b) => a.name.localeCompare(b.name));

  return derivedVarieties;
});

export const selectCropVarieties = createSelector(selectTGAVarietiesState, (state) => state.cropVarieties);
